module.exports = __webpack_public_path__ + "img/emoji_81.48896b62.png";